/* eslint-disable */
import { Button } from "@material-ui/core";
import { Assignment } from "@material-ui/icons";
import { Options, Column } from "material-table";
import React from "react";

/** @type Options */

export const optionTablesBroadcast = {
    pageSize: 20,
    pageSizeOptions: [5, 10, 20, 50],
    actionsColumnIndex: -1,
    emptyRowsWhenPaging: false,
    headerStyle: {
        fontSize: 15,
    },
    debounceInterval: 500,
    // have not affect table
    totalData: 0,
    order: "",
    direction: "",
};

export const columnsTablePayBroadCast = props => {
    /** @type Column */
    const array = [
        {
            field: "messageTitle",
            title: "Title",
        },
        {
            field: "date",
            title: "Date",
        },
        {
            field: "messageBody",
            title: "Message",
        },
        {
            field: "linkUrl",
            title: "Link URL",
        },
    ];
    return array;
};
